import { axios } from '@/utils/request'

/**
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    // url: '/auth/login',
    url: '/ucs-auth/account/login',
    // url: '/ucs-tenant/tenant/account/login',
    method: 'post',
    data: parameter
  })
}

export function logout() {
  return axios({
    url: '/ucs-auth/account/logout',
    // url: '/ucs-tenant/tenant/account/logout',
    method: 'get'
  })
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: '/account/sms',
    method: 'post',
    data: parameter
  })
}

// 获取用户信息
export function getInfo() {
  return axios({
    url: '/ucs-auth/account/full-account-info',
    method: 'post'
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return axios({
    url: '/auth/2step-code',
    method: 'post',
    data: parameter
  })
}

export function modifyPassword(data) {
  return axios({
    url: '/ucs-auth/account/modify-password',
    method: 'post',
    data
  })
}

export function resetPasswordVerify(data) {
  return axios({
    url: '/ucs-auth/account/reset-password-verify',
    // url: '/ucs-tenant/tenant/account/reset-password-verify',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return axios({
    url: '/ucs-auth/account/reset-password',
    // url: '/ucs-tenant/tenant/account/reset-password',
    method: 'post',
    data
  })
}

export function modifyPasswordVerify(data) {
  return axios({
    url: '/ucs-auth/account/modify-password-verify',
    method: 'post',
    data
  })
}

export function modifyMobileVerify(data) {
  return axios({
    // url: '/ucs-auth/account/modify-mobile-verify',
    url: '/ucs-auth/account/modify-mobile-verify',
    method: 'post',
    data
  })
}

export function modifyMobile(data) {
  return axios({
    url: '/ucs-auth/account/modify-mobile',
    method: 'post',
    data
  })
}

// 发送验证码，不需要手机号
export function sendVerifyCode(data) {
  return axios({
    // url: '/ucs-tenant/tenant/account/send-auth-verify-code',
    url: '/ucs-auth/account/send-auth-verify-code',
    method: 'post',
    data
  })
}

// 发送验证码，需要手机号
export function sendAuthVerifyCode(data) {
  return axios({
    url: '/ucs-auth/account/send-auth-verify-code',
    // url: '/ucs-tenant/tenant/account/send-auth-verify-code',
    method: 'post',
    data
  })
}

// 切换企业
export function switchTenant(data) {
  return axios({
    url: '/ucs-auth/account/switch-tenant',
    method: 'post',
    data
  })
}

// 转移企业管理员
export function transferTenantAdmin(data) {
  return axios({
    url: '/ucs-auth/tenant-user/transfer-tenant-admin',
    method: 'post',
    data
  })
}

// 查询租户用户
export function findTenantUsers(data) {
  return axios({
    url: '/ucs-auth/tenant-user/find-tenant-user-page',
    method: 'post',
    data
  })
}

// 首页获取子系统菜单列表
// export function getHomeSubSystemList(data = {}) {
//   return axios({
//     url: '/ucs-tenant/subsystem/get-home-sub-system-list',
//     method: 'post',
//     data
//   })
// }

// 生成图形验证码
export function generateCaptha(data) {
  return axios({
    url: '/ucs-auth/account/generate-captcha',
    // url: '/ucs-tenant/tenant/account/generate-captcha',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 初始化状态查询
export function queryStatus() {
  return axios({
    url: '/ucs-org/initialize-data/status',
    method: 'post',
    data: {},
    timeout: 120000
  })
}

// 初始化租户数据
export function init() {
  return axios({
    url: '/ucs-org/initialize-data/init',
    method: 'post',
    data: {},
    timeout: 100000000
  })
}

// 用户信息查询
export function getUserInfo(data) {
  return axios({
    // url: 'ucs-auth/tenant-user/detail',
    url: '/ucs-auth/tenant-user/info',
    method: 'post',
    data
  })
}
// 员工信息查询
export function getEmployeeInfo(data) {
  return axios({
    url: 'ucs-org/org-employee/get-employee-detail',
    method: 'post',
    data
  })
}
// 获取子系统列表
export function getSystemList (data) {
  return axios({
    url: 'finsaas-mcs/navi/access-subsystems',
    method: 'post',
    data
  })
}
// 设置默认访问的子系统
export function setDefaultSystem (data) {
  return axios({
    url: 'finsaas-mcs/navi/set-default-access',
    method: 'post',
    data
  })
}
// 取消设置默认访问的子系统
export function removeDefaultSystem (data) {
  return axios({
    url: 'finsaas-mcs/navi/remove-default-access',
    method: 'post',
    data
  })
}
// 获取系统权限
export function getMenuInfo (data) {
  return axios({
    // url: '/ucs-auth/tenant-user/menu-info',
    // 新接口
    // url: '/ucs-auth/tenant-user/v2/menu-info',
    // 更新的接口
    url: '/finsaas-mcs/menu/user-menu-list',
    method: 'post',
    data
  })
}

// 获取其他子系统跳转过来的系统权限
export function getRoleMenu(data) {
  return axios({
    url: '/ucs-auth/tenant-user/share-menu-info',
    method: 'post',
    data
  })
}
/**
 * 是否可以进入子系统校验
 */
export function checkCar(params) {
  return axios({
    url: '/ucs-auth/subsystem/accessibility-check',
    method: 'post',
    data: params
  })
}
/**
 * 强制登出
 */
export function singOut(params) {
  return axios({
    // url: '/ucs-tenant/tenant/account/force-logout-users',
    url: '/ucs-auth/account/force-logout-users',
    method: 'post',
    data: params
  })
}

/**
 * 获取切换企业列表
 */
export function getMode (params) {
  return axios({
    url: '/finsaas-mcs/auth/tenant/list',
    method: 'post',
    data: params
  })
}
/**
*  查看已发布区号
*/
export function getAreaCodeList (data) {
  return axios({
    url: '/ucs-auth/areaCode/getAreaCodes',
    method: 'post',
    data
  })
}

export function checkLogin (data) {
  let hostname = location.hostname
  if (hostname === 'localhost') {
    hostname = 'test1.weihaiqiaocai.com'
  }
  const arr = hostname.split('.')
  let env = 'pro'
  // 二级域名
  if (arr.length === 3) {
    env = arr[0]
  }
  if (env === 'www') env = 'pro'
  return axios({
    url: `${location.origin}/${env}/api/uac/oapi/sso/checkLogin`,
    method: 'post',
    data
  })
}
/**
*  查看全部子系统，不需携带token
*/
export function getAllSubsystem () {
  return axios({
    url: '/ucs-auth/subsystem/all',
    method: 'post'
  })
}
/**
*  超级登录，发送密钥
*/
export function sendLoginKey (data) {
  return axios({
    url: '/ucs-auth/auth-super-login/send',
    method: 'post',
    data
  })
}
/**
*  超级登录，登录
*/
export function superLogin (data) {
  return axios({
    url: '/ucs-auth/auth-super-login/submit',
    method: 'post',
    data
  })
}

export function listAgentByUserId (data = { tenantId: '' }) {
  return axios({
    url: '/ucs-org/agent/manage/listAgentByUserId',
    method: 'post',
    data
  })
}
